import { styled } from '../../../../../styled-system/jsx';
import { cva } from '../../../../../styled-system/css';

const h1 = cva({
  base: {
    fontSize: 'h1',
    fontWeight: 'bold',
  },

  variants: {
    use: {
      default: {
        color: 'headerText',
      },

      appName: {
        color: 'headerFg',
      },
    },
  },

  defaultVariants: {
    use: 'default',
  },
});

export const H1 = styled('h1', h1);
